Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var basic_1 = require("./basic");
exports.styles = tslib_1.__assign(tslib_1.__assign({}, basic_1.basicClasses), { container: tslib_1.__assign(tslib_1.__assign({}, basic_1.basicClasses.container), { color: '#eb001b', backgroundColor: '#eb001b', '&::before': {
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 32,
            height: 10,
            backgroundColor: '#fff',
            transform: 'translate(-50%, -50%)'
        }, '&::after': {
            content: '""',
            top: 4,
            left: 4,
            position: 'absolute',
            width: 'calc(100% - 8px)',
            height: 'calc(100% - 8px)',
            color: 'inherit',
            borderRadius: '50%',
            boxShadow: '0 0 0 4px',
            opacity: 0.5,
            animation: 'StatusLogo-pulsationAnimation 500ms ease-in-out'
        } }) });
